import { injectable, inject } from 'inversify';
import { RpcSuccess } from '@dealroadshow/json-rpc-dispatcher';
import Request from '@framework/api/Rpc/Request';
import { type IDispatcher } from '@dm-portal/json-rpc-dispatcher';
import DITypes from '@dm-portal/json-rpc-dispatcher/DITypes';

@injectable()
class UserRepository {
  constructor(@inject(DITypes.JsonRpcDispatcher) private dmPortalDispatcher: IDispatcher) {}

  async getEmailsFullInfo(data = {}) {
    let request = new Request('user.queries.get_users', data);
    let response = await this.dmPortalDispatcher.call<RpcSuccess>(request);

    return response.getResult().payload;
  }

  async resendVerificationEmail(
    { email, entryCode, roadshowId }: { email: string, entryCode?: string | null, roadshowId?: number | null },
  ) {
    let request = new Request('user.resend_verification_email', { email, entryCode, roadshowId });

    return this.dmPortalDispatcher.request(request);
  }
}

export default UserRepository;
